<template>
	<div>
		<span
			v-if="!inWishlist"
			key="not_in_wishlist"
			ref="wishlistButton"
			@click="addToWishList"
			class="btn-product btn-wishlist mr-6"
			><i class="fa-regular fa-heart"></i>&nbsp;&nbsp;Add to Wishlist</span
		>
		<span
			v-if="inWishlist"
			key="in_wishlist"
			ref="wishlistButton"
			@click="removeFromWishList"
			class="btn-product btn-wishlist mr-6"
			><i class="fa-solid fa-heart"></i>&nbsp;&nbsp;Added to Wishlist</span
		>
	</div>
</template>
<style scoped>
	span {
		cursor: pointer;
	}
</style>
<script>
	export default {
		props: {
			wishlist_link: String,
		},
		data() {
			return {
				inWishlist: null,
			};
		},
		computed: {
			logged_in() {
				try {
					return JSON.parse(window.sessionStorage.getItem("logged_in"))
						.value;
				} catch (error) {
					return false;
				}
			},
			wishlist() {
				if (!this.logged_in) {
					return [];
				}

				try {
					return JSON.parse(window.localStorage.getItem("wishlist"));
				} catch (error) {
					return [];
				}
			},
		},
		mounted() {
			this.isInWishlist();
		},
		methods: {
			addToWishList() {
				let _this = this;
				if (this.logged_in) {
					axios
						.post(this.wishlist_link, {
							path: window.location.pathname,
							method: "add",
						})
						.then(function (response) {
							_this.inWishlist = true;
						})
						.catch(function (response) {})
						.then(function (response) {});
				} else {
					const wishlist = [..._this.wishlist];
					if (!wishlist.includes(window.location.pathname)) {
						wishlist.push(window.location.pathname);
					}
					window.localStorage.setItem(
						"wishlist",
						JSON.stringify(wishlist)
					);
					_this.inWishlist = true;
				}
				/* Place Added To Wishlist Notifications Below */
			},
			removeFromWishList() {
				let _this = this;
				if (this.logged_in) {
					axios
						.post(this.wishlist_link, {
							path: window.location.pathname,
							method: "remove",
						})
						.then(function (response) {
							_this.inWishlist = false;
						})
						.catch(function (response) {})
						.then(function (response) {});
				} else {
					let wishlist = [..._this.wishlist];

					for (let counter = 0; counter < wishlist.length; counter++) {
						if (wishlist[counter] == window.location.pathname) {
							wishlist.splice(counter, 1);
							break;
						}
					}
					window.localStorage.setItem(
						"wishlist",
						JSON.stringify(wishlist)
					);
				}
				_this.inWishlist = false;
				/* Place Removed from Wishlist Notifications Below */
			},
			isInWishlist() {
				let _this = this;
				if (this.logged_in) {
					axios
						.post(this.wishlist_link, {
							path: window.location.pathname,
							method: "check",
						})
						.then(function (response) {
							if (response.data.in_wishlist) {
								_this.inWishlist = true;
							} else {
								_this.inWishlist = false;
							}
						})
						.catch(function (response) {
							_this.inWishlist = false;
						})
						.then(function (response) {});
				} else {
					if (_this.wishlist.includes(window.location.pathname)) {
						_this.inWishlist = true;
					} else {
						_this.inWishlist = false;
					}
				}
			},
		},
	};
</script>
